import { Component, model } from '@angular/core';
import { NavigationLinks } from './navigation-links/navigation-links';
import { RecentChatsSection } from '../recent-chats-section/recent-chats-section';
import { NavFooter } from './nav-footer/nav-footer';
import { MatButtonModule } from '@angular/material/button';
import { ProductName } from './product-name';

@Component({
  selector: 'nav-sidebar-content',
  templateUrl: './nav-sidebar-content.html',
  styleUrl: './nav-sidebar-content.scss',
  imports: [RecentChatsSection, NavFooter, MatButtonModule, NavigationLinks, ProductName],
})
export class NavSidebarContent {
  isCollapsed = model.required<boolean>();
}
